module.exports = __webpack_public_path__ + "assets/pw_spray.f964dfc5.svg";